import { cn } from "@/lib/utils";

type CakewalkV2LogoTone = "ink" | "white" | "accent";
type CakewalkV2LogoSize = "sm" | "md" | "lg" | "mark";

interface CakewalkV2LogoProps {
  className?: string;
  size?: CakewalkV2LogoSize;
  tone?: CakewalkV2LogoTone;
}

const sizeClass: Record<CakewalkV2LogoSize, string> = {
  sm: "h-6 w-[142px]",
  md: "h-8 w-[189px]",
  lg: "h-10 w-[236px]",
  mark: "h-8 w-8",
};

const toneClass: Record<CakewalkV2LogoTone, string> = {
  ink: "bg-cw-v2-ink",
  white: "bg-cw-v2-letter-white",
  accent: "bg-cw-v2-reliant-red",
};

export function CakewalkV2Logo({ className, size = "md", tone = "ink" }: CakewalkV2LogoProps) {
  const isMark = size === "mark";

  return (
    <span
      aria-label="Cakewalk"
      role="img"
      className={cn("inline-block shrink-0", sizeClass[size], toneClass[tone], className)}
      style={{
        WebkitMask: `url('/cakewalk-v2-logo.svg') ${isMark ? "left center" : "center"} / ${
          isMark ? "auto 100%" : "contain"
        } no-repeat`,
        mask: `url('/cakewalk-v2-logo.svg') ${isMark ? "left center" : "center"} / ${
          isMark ? "auto 100%" : "contain"
        } no-repeat`,
      }}
    />
  );
}
